import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { organizationI } from 'app/core/interfaces/organization';
import Organization from 'app/core/models/Organization';
import { Action } from 'rxjs/internal/scheduler/Action';
import { SecretaryAPIResponse, SecretaryInterface, secretaryI } from 'app/core/interfaces/secretary';
import { Observable, map } from 'rxjs';
import { SecretaryAdapter } from 'app/core/adapters/secretary.adapter';

@Injectable({
  providedIn: 'root'
})


export class SecretaryService {

  constructor(private http: HttpClient, private secretaryAdapter: SecretaryAdapter) { }

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  public searchByToken(id: string) {
    return this.http.get<SecretaryInterface>(
      `${environment.apiUrl}/secretarias-secretaries/token_id/${id}`,
      { headers: this.getHeaders() }
    );
  }


  public create(secretary: any) {
    return this.http.post(`${environment.apiUrl}/secretarias-secretaries`, secretary)
  }

  public createNew(secretary: SecretaryInterface): Observable<SecretaryInterface> {

    const secretaryFHIR = this.secretaryAdapter.adaptToAPIFormat(secretary)
    secretaryFHIR.token_id = localStorage.getItem('token_id') ?? '' ?? ''

    return this.http.post<SecretaryAPIResponse>(`${environment.apiUrl}/secretarias-secretaries`, secretaryFHIR)
      .pipe(
        map((secretary: SecretaryAPIResponse) => this.secretaryAdapter.adapterToModel(secretary))
      );
  }

  public update(id: string, params: secretaryI) {
    return this.http.put(`${environment.apiUrl}/secretarias-secretaries/${id}`, params)
  }

  public updateNew(secretary_id: string, secretary: SecretaryInterface) {

    const secretaryFHIR = this.secretaryAdapter.adaptToAPIFormat(secretary)

    return this.http.put<SecretaryAPIResponse>(`${environment.apiUrl}/secretarias-secretaries/${secretary_id}`, secretaryFHIR)
      .pipe(
        map((secretary: SecretaryAPIResponse) => this.secretaryAdapter.adapterToModel(secretary))
      );

  }

  public delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-secretaries/${id}`)
  }

  public show(id: string) {
    return this.http.get<secretaryI>(`${environment.apiUrl}/secretarias-secretaries/${id}`)
  }

  public showNew(secretary_id: string): Observable<SecretaryInterface> {

    return this.http.get<SecretaryAPIResponse>(`${environment.apiUrl}/secretarias-secretaries/${secretary_id}`)
      .pipe(
        map((secretary: SecretaryAPIResponse) => this.secretaryAdapter.adapterToModel(secretary))
      );
  }

  public list() {
    return this.http.get(`${environment.apiUrl}/secretarias-secretaries`)
  }

  public listNew(): Observable<SecretaryInterface[]> {
    return this.http.get<SecretaryAPIResponse[]>(`${environment.apiUrl}/secretarias-secretaries`)
      .pipe(
        map((organization: SecretaryAPIResponse[]) =>
          organization.map((item: SecretaryAPIResponse) => this.secretaryAdapter.adapterToModel(item)))
      );
  }




}
